module.exports = __webpack_public_path__ + "img/user.fe7ccf67.png";